import { SVGProps } from "react"
const ReadMoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#5B7553"
      d="m9.707 16.95 5.707-5.707-5.707-5.707L8.293 6.95l4.293 4.293-4.293 4.293 1.414 1.414Z"
    />
  </svg>
)
export default ReadMoreIcon
